// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-modal .modal-content{border-radius:.3rem!important}.info-modal .modal-body{padding:20px!important}.info-modal .modal-body button{margin-top:20px}", ""]);
// Exports
module.exports = exports;
